<template>
  <main>
    <slot />
  </main>
</template>

<script setup>
import { usePropertyStore } from "~/store/property";
const propertyStore = usePropertyStore();
</script>

<style lang="scss" scoped></style>
